/**
 * Qué probar cuando no se te ocurre nada (GKTIBO-76).
 *
 * > «Nadie le escribe un reclamo furioso a su propio bot. El dueño prueba lo
 * > que espera que funcione, no lo que puede salir mal.»
 *
 * Vive aparte de `ProbarElBot` por el mismo motivo que la tarjeta de
 * confirmación vive aparte de la entrevista: juntas pasaban las 300 líneas
 * (D4), y esto se lee mejor solo.
 *
 * **Precargan, no disparan.** El mensaje va al campo y queda editable: una
 * sugerencia que envía sola y muestra una respuesta preparada es una demo, no
 * una prueba (G3, L27).
 */

import { armarSugerencias } from './sugerencias-de-prueba';

export interface SugerenciasDePruebaProps {
  servicios: string[];
  herramientas: string[];
  /** Escribe el mensaje en el campo. No lo envía. */
  onElegir: (mensaje: string) => void;
}

export function SugerenciasDePrueba({
  servicios,
  herramientas,
  onElegir,
}: SugerenciasDePruebaProps) {
  return (
    <ul className="probar-sugerencias">
      {armarSugerencias({ servicios, herramientas }).map((s) => (
        <li key={s.tipo}>
          <button type="button" data-testid="probar-sugerencia" onClick={() => onElegir(s.mensaje)}>
            <span className="probar-sugerencia-mensaje">{s.mensaje}</span>
            <span className="probar-sugerencia-porque">{s.porQue}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
